import styled from "styled-components";

import { Color, Font, breakpoints, ColorDark } from "@/shared/Constants";
import { onexoneTitle, onexoneBoxTtile } from "../mixins-modules";

export const ContentOnexOne = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  overflow: hidden;
  height: auto;
  margin: 30px 0 8px;
  gap: 18px;
  ${breakpoints.phone} {
    margin: 0 0 25px;
  }
  picture {
    height: 100px;
    img {
      width: 100px !important;
      height: 100px !important;
      //filter: grayscale(1);
    }
  }
  .content {
    width: 100%;
  }
  .mt {
    ${onexoneBoxTtile}
    ${(props) => props.mamsEnabled && "margin-top:35px"};
    ${breakpoints.phone} {
      margin: 10px 0;
    }
    h2.title {
      ${onexoneTitle}
      ${Font.vintageSans}
      font-size: 24px;
      line-height: 30px;
      text-transform: uppercase;
      &.shortenTitle {
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 4;
        -webkit-box-orient: vertical;
        /* min-height: 75px; */
        ${breakpoints.phone} {
          min-height: auto;
          -webkit-line-clamp: inherit;
        }
      }
      ${breakpoints.darkMode} {
        [data-theme="dark"] & {
          color: ${ColorDark.textLight};
        }
      }
    }
    .volanta,
    .data-txt {
      display: none;
    }
    .bajada {
      ${Font.vintageGeorgia}
      font-size: 15px;
      line-height: 20px;
      color: ${Color.black000};
      margin-top: 5px;

      display: -webkit-box;
      -webkit-line-clamp: 3; /* Número de líneas a mostrar */
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis; /* Muestra puntos suspensivos */
      ${breakpoints.darkMode} {
        [data-theme="dark"] & {
          color: ${ColorDark.textLight};
        }
      }
    }
    .bottomSummary {
      margin-bottom: 10px;
      ${breakpoints.phone} {
        margin: 0 0 10px 0;
      }
    }
  }
  .content {
    order: 1;
  }
  .date {
    ${Font.vintageGeorgia}
    font-size: 15px;
    color: ${Color.black000};
    padding-bottom: 12px;
    ${breakpoints.phone} {
      padding-bottom: 5px;
    }
    ${breakpoints.darkMode} {
      [data-theme="dark"] & {
        color: ${ColorDark.textLight};
      }
    }
  }
  .host-info-name {
    text-transform: uppercase;
    ${Font.vintageGeorgiaBold}
    margin-bottom: 5px;
    font-size: 14px;
    color: ${Color.black000};
    ${breakpoints.darkMode} {
      [data-theme="dark"] & {
        color: ${ColorDark.textLight};
      }
    }
  }
  .host-info-description {
    ${Font.vintageGeorgia}
    font-size: 12px;
    line-height: 15px;
    color: ${Color.black000};
    ${breakpoints.darkMode} {
      [data-theme="dark"] & {
        color: ${ColorDark.textLight};
      }
    }
  }
`;
